module.exports = __webpack_public_path__ + "img/menucn_3_2.5cc046fe.svg";